import React from 'react';
import classnames from 'classnames';
import { CardContent, Typography, Button, withStyles, Icon, CircularProgress } from '@material-ui/core';
import Spinner from 'react-spinkit';
import { getSubTasks } from '../../firebase/db/project';
import { db } from '../../firebase/firebase';
import { MAIN_COLOR } from '../../firebase-config';

const styles = theme => ({
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: 165,
        minWidth: 165,
        borderRight: '1px solid #b4b4b4',
        margin: '10px 0',
        minHeight: '100px',
        padding: '0 15px'
    },

    taskStatus: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        height: '10px',
        width: '100%',
        marginTop: '5px'
    },
    task: {
        width: '20%'
    },
    button: {
        padding: '2px 16px',
        marginTop: '5px',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 25,
        justifyContent: 'space-between',
        width: '100%'
    },
    rowCycles: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 25,
        justifyContent: 'space-between',
        width: '100%'
    },
    rowIcon: {
        display: 'flex',
        flexDirection: 'row',
    },
    icon: {
        color: 'green'
    }

});
class ProjectListCycle extends React.Component {

    state = {
        learnColor: '#ddd',
        defineColor: '#ddd',
        buildColor: '#ddd',
        testColor: '#ddd',
        finishedProcess: 0,
        isLoading: false
    };

    componentDidMount() {
        const { projectCycle, cycleId } = this.props;
        if (projectCycle.tasks) {
            this.setState({ isLoading: true })
            Promise.all([
                this.calculateColor(projectCycle.tasks.learn, 'learnColor'),
                this.calculateColor(projectCycle.tasks.define, 'defineColor'),
                this.calculateColor(projectCycle.tasks.build, 'buildColor'),
                this.calculateColor(projectCycle.tasks.test, 'testColor')
            ])
                .then(() => this.setState({ isLoading: false }))
        }

        db.ref('subTasks').orderByChild('cycle').equalTo(cycleId).on('child_added', () => {
            if (this.props.projectCycle.tasks) {
                this.setState({ isLoading: true })
                Promise.all([
                    this.calculateColor(this.props.projectCycle.tasks.learn, 'learnColor'),
                    this.calculateColor(this.props.projectCycle.tasks.define, 'defineColor'),
                    this.calculateColor(this.props.projectCycle.tasks.build, 'buildColor'),
                    this.calculateColor(this.props.projectCycle.tasks.test, 'testColor')
                ])
                    .then(() => this.setState({ isLoading: false }))
            }
        });
        db.ref('subTasks').orderByChild('cycle').equalTo(cycleId).on('child_removed', () => {
            if (this.props.projectCycle.tasks) {
                this.setState({ isLoading: true })
                Promise.all([
                    this.calculateColor(this.props.projectCycle.tasks.learn, 'learnColor'),
                    this.calculateColor(this.props.projectCycle.tasks.define, 'defineColor'),
                    this.calculateColor(this.props.projectCycle.tasks.build, 'buildColor'),
                    this.calculateColor(this.props.projectCycle.tasks.test, 'testColor')
                ])
                    .then(() => this.setState({ isLoading: false }))
            }
        });
        db.ref('subTasks').orderByChild('cycle').equalTo(cycleId).on('child_changed', () => {
            if (this.props.projectCycle.tasks) {
                this.setState({ isLoading: true })
                Promise.all([
                    this.calculateColor(this.props.projectCycle.tasks.learn, 'learnColor'),
                    this.calculateColor(this.props.projectCycle.tasks.define, 'defineColor'),
                    this.calculateColor(this.props.projectCycle.tasks.build, 'buildColor'),
                    this.calculateColor(this.props.projectCycle.tasks.test, 'testColor')
                ])
                    .then(() => this.setState({ isLoading: false }))
            }
        });

        db.ref('cycles').orderByKey().equalTo(cycleId).on('child_added', () => {
            if (this.props.projectCycle.tasks) {
                this.setState({ isLoading: true })
                Promise.all([
                    this.calculateColor(this.props.projectCycle.tasks.learn, 'learnColor'),
                    this.calculateColor(this.props.projectCycle.tasks.define, 'defineColor'),
                    this.calculateColor(this.props.projectCycle.tasks.build, 'buildColor'),
                    this.calculateColor(this.props.projectCycle.tasks.test, 'testColor')
                ])
                    .then(() => this.setState({ isLoading: false }))
            }
        });
        db.ref('cycles').orderByKey().equalTo(cycleId).on('child_removed', () => {
            if (this.props.projectCycle.tasks) {
                this.setState({ isLoading: true })
                Promise.all([
                    this.calculateColor(this.props.projectCycle.tasks.learn, 'learnColor'),
                    this.calculateColor(this.props.projectCycle.tasks.define, 'defineColor'),
                    this.calculateColor(this.props.projectCycle.tasks.build, 'buildColor'),
                    this.calculateColor(this.props.projectCycle.tasks.test, 'testColor')
                ])
                    .then(() => this.setState({ isLoading: false }))
            }
        });
        db.ref('cycles').orderByKey().equalTo(cycleId).on('child_changed', () => {
            if (this.props.projectCycle.tasks) {
                this.setState({ isLoading: true })
                Promise.all([
                    this.calculateColor(this.props.projectCycle.tasks.learn, 'learnColor'),
                    this.calculateColor(this.props.projectCycle.tasks.define, 'defineColor'),
                    this.calculateColor(this.props.projectCycle.tasks.build, 'buildColor'),
                    this.calculateColor(this.props.projectCycle.tasks.test, 'testColor')
                ])
                    .then(() => this.setState({ isLoading: false }))
            }
        });


    }

    componentDidUpdate(prevProps) {
        const { projectCycle } = this.props;
        if (!prevProps.projectCycle.tasks && projectCycle.tasks) {
            if (projectCycle.tasks) {
                this.setState({ isLoading: true })
                Promise.all([
                    this.calculateColor(projectCycle.tasks.learn, 'learnColor'),
                    this.calculateColor(projectCycle.tasks.define, 'defineColor'),
                    this.calculateColor(projectCycle.tasks.build, 'buildColor'),
                    this.calculateColor(projectCycle.tasks.test, 'testColor')
                ])
                    .then(() => this.setState({ isLoading: false }));

            }
        }
    }

    calculateColor = (tasks, state) => {
        return getSubTasks(tasks)
            .then((subTasks) => {
                const isAssignedTo = Object.keys(subTasks).findIndex((subTaskId) => subTasks[subTaskId].assignedTo) > -1;
                if (isAssignedTo) {
                    const isStarted = Object.keys(subTasks).reduce((result, subTaskId) => {
                        return result || subTasks[subTaskId].finished;
                    }, false);
                    const isFinished = Object.keys(subTasks).reduce((result, subTaskId) => {
                        return result && subTasks[subTaskId].finished;
                    }, true);
                    if (isFinished) {
                        return '#0f0';
                    } else if (!isStarted) {
                        return '#ff0';
                    }
                    //started but not finished
                    return '#f80';
                }
                return '#ddd';
            }).then(color => {
                if (color === '#0f0' && this.state[state] === '#ddd') {
                    this.setState({ finishedProcess: this.state.finishedProcess + 1 })
                }
                this.setState({ [state]: color })
            });
    }

    render() {
        const { projectId, cycleId, onWorkerViewTasks, projectCycle, onCreateUXCycleClick, classes } = this.props;
        const { finishedProcess, learnColor, defineColor, buildColor, testColor, isLoading } = this.state;
        return isLoading ? (
            <Spinner style={{ width: 50, height: 50 }} name="circle" color={MAIN_COLOR} />
        ) : (
                <div className={classes.cardContent}>

                    <div className={classes.rowCycles}>
                        <Typography>{projectCycle.title ? projectCycle.title : `Cycle ${projectCycle.index + 1}`}</Typography>
                        <span className={classes.rowIcon}>
                            {finishedProcess == 4 && <Icon
                                className={classnames(classes.icon, `far fa-check-circle`)}
                                fontSize="small"
                                color='green'
                            />
                            }
                        </span>
                    </div>
                    <div className={classes.taskStatus}>
                        <span className={classes.task} style={{ backgroundColor: learnColor }} />
                        <span className={classes.task} style={{ backgroundColor: defineColor }} />
                        <span className={classes.task} style={{ backgroundColor: buildColor }} />
                        <span className={classes.task} style={{ backgroundColor: testColor }} />
                    </div>
                    <div className={classes.row}>
                        {learnColor === '#ddd' && defineColor === '#ddd' && buildColor === '#ddd' && testColor === '#ddd' ?
                            <Button
                                size="small"
                                color="primary"
                                className='blink_me'
                                onClick={() => onCreateUXCycleClick(projectId, cycleId)}>
                                <Typography variant="h5" >TASKS ZUWEISEN</Typography>
                            </Button>
                            :
                            <div>
                                <Button
                                    size="small"
                                    color="primary"
                                    className={classes.button}
                                    onClick={onWorkerViewTasks}>
                                    <Typography variant="h5" >Tasks</Typography>
                                </Button>
                                <Button
                                    size="small"
                                    color="primary"
                                    className={classes.button}
                                    onClick={() => onCreateUXCycleClick(projectId, cycleId)}>
                                    <Typography variant="h5" >Cycles</Typography>
                                </Button>
                            </div>
                        }
                    </div>
                </div>
            )
    };
}

export default withStyles(styles)(ProjectListCycle);



// WEBPACK FOOTER //
// ./src/components/common/ProjectListCycle.js